export interface ISectionProps {
  id?: string;
  children: React.ReactNode | React.ReactNode[];
  sectionClass?: string;
  className?: string;
}

export const Section = ({
  id = "",
  children,
  sectionClass = "",
  className = "",
}: ISectionProps) => {
  return (
    <section id={id} className={`flex justify-center w-full ${sectionClass}`}>
      <div
        className={`container flex my-16 w-full mx-6 lg:mx-[100px] max-w-[1440px] ${className}`}
      >
        {children}
      </div>
    </section>
  );
};
